export const checkPath = (pathname: string, currentpath: string) => {
    return pathname.includes(currentpath);
}


export enum UpdateAppoinmentStatusEnum {
    patientesign = 1,
    patientappstart = 2,
    Therapistappstart = 3,
    Therapistappcancel = 4,
    Therapistappreschedule = 5,
    Patientappcomplete = 6,
    patientapppaymentstatus = 7,
    patientappratingsaved = 8,
    patientAssessmentPDFrequest = 9,
}

export enum AssessmentMaster {
    Thoracic = 1,
    Cervical = 2,
    Lumbar = 3,
    Lower_Extremities = 4,
    Upper_Extremities = 5,
    Re_Assessment = 6,
    Vestibular = 7,
    Other_Eval = 8,
    Other_FollowUp = 9,
    Other_Eval_OT = 10,
    Other_FollowUp_OT = 11,
    PatientRefuse = 12,
}

export enum UserStatus {
    Registration = 1,
    Approval_pending = 2,
    Approved = 3,
    Approvedprofileupdated = 4,
    TherapistDraft = 5,
    TherapistSignandSubmit = 6,
    ScheduleAvailable = 7,
    ScheduleTimeSlotSaved = 8,
    ScheduleBooked = 9,
    ScheduleBackDate = 10,
    AppoinmentBook = 11,
    AppoinmentCancel = 12,
    AppoinmentReschudel = 13,
    AppoinmentCompleted = 14,
    UnRead = 15,
    Read = 16,
    // Messaging Related
    MessageSent = 17,
    MessageDraft = 18,
    MessageInbox = 19,
    MessageTrash = 20,
    MessageReceiverDelete = 21,
    MessageSenderDelete = 22,
    Paid = 23,
    UnPaid = 24,
    Registration_Reject = 25,
    Login_Disable = 26,
    AppoinmentSave = 27,
    AppoinmentRefuse = 28,
}

export enum LoginType {
    Therapist = 1,
    Patient = 2,
    Admin = 3,
    CompanyAdmin = 4
}

export enum UserType {
    Therapist = 1,
    Patient = 2,
    Admin = 3,
    CompanyAdmin = 4
}

export enum Companies {
    FirstCompany = 1,
    SecondCompany = 2,
    ThirdCompany = 3,
    kingstree = 4,
    Vinfotech = 5,
    Empatha = 6,
    GroupHealth = 7,
    MarineMax = 8,
    VPTFreeRisk = 9,
    TrinityCaptive = 10,
    benefitSMART = 11,
    HealthcareHighways = 12,
    Ulbrich = 13,
    CAPrisonSystem = 14,
    Pepsi = 15,
    NVDC = 16,
    GEOFL = 17,
    GEOAZ = 18,
    GEOAZKingman = 19,
    GEOAZCentralArizona = 20,
    GEOAZFlorenceWest = 21,
    GEOAZPhoenixWest = 22,
    GEOAZCentral = 24
}

export enum AllowedDateTimeFormat {
    DefaultDate = "01/01/2012 ",
    DateTime = "MM/dd/yyyy hh:mm a",
    Date = "MM/dd/yyyy",
    UIDate = "MM-dd-yyyy",
    YearDate = "yyyy-MM-dd hh:mm",
    CalendarDate = "ddd MM/dd/yyyy",
    Time = "hh:mm a",
    SingedDt = "MMMM-dd-yyyy hh:mm a",
    NoteDt = "MMMM-dd-yyyy",
    MsgDt = "MMM-dd-yyyy, hh:mm a",
    MsgDtToDisplay = "MM-dd-yyyy, hh:mm a",
}

export enum EnumAppRej {
    Approve= 1,
    Reject= 2
}


